// The tool was renamed Live Event Analytics, moving its URLs off `/market-analytics`
// onto `/live-event-analytics`. Kept in its own dependency-free module (rather than
// inlined in AppRoutes.tsx) so it can be unit tested without pulling in AppRoutes'
// full page-component import tree, which drags in ESM-only packages Jest can't parse.
export function buildLegacyMarketAnalyticsRedirectTarget(pathname: string, search: string, hash: string): string {
  return `${pathname.replace(/^\/market-analytics/, '/live-event-analytics')}${search}${hash}`
}
